import React from 'react';
import { X, Check, Star, Zap, Shield, Crown } from 'lucide-react';
import { handleCheckout } from '../services/stripeService.ts';
import { Button } from './Button.tsx';

interface PricingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PricingModal: React.FC<PricingModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative w-full max-w-2xl bg-surface border border-primary/20 rounded-2xl shadow-[0_0_50px_rgba(34,211,238,0.2)] overflow-hidden animate-in fade-in zoom-in-95">
        
        {/* Header */}
        <div className="relative bg-gradient-to-r from-zinc-900 to-black p-8 text-center border-b border-white/5">
            <div className="absolute top-4 right-4">
                <button onClick={onClose} className="p-2 text-subtext hover:text-white transition-colors"><X className="w-5 h-5"/></button>
            </div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-bold uppercase tracking-wider mb-4">
                <Crown className="w-3 h-3" /> Upgrade to Pro
            </div>
            <h2 className="text-3xl font-bold text-white mb-2">Unlock Unlimited Humanization</h2>
            <p className="text-subtext text-sm">Remove limits and access the world's most advanced forensic engine.</p>
        </div>

        {/* Content */}
        <div className="p-8 grid md:grid-cols-2 gap-8">
            {/* Free Tier */}
            <div className="opacity-50 grayscale hover:grayscale-0 transition-all duration-500">
                <h3 className="text-lg font-bold text-white mb-4">Basic</h3>
                <ul className="space-y-3 mb-6">
                    <li className="flex items-center gap-2 text-sm text-subtext"><Check className="w-4 h-4 text-zinc-500"/> 500 words per scan</li>
                    <li className="flex items-center gap-2 text-sm text-subtext"><Check className="w-4 h-4 text-zinc-500"/> Standard Humanization</li>
                    <li className="flex items-center gap-2 text-sm text-subtext"><X className="w-4 h-4 text-red-500"/> No File Export</li>
                </ul>
                <div className="text-2xl font-bold text-white mb-4">$0</div>
                <Button variant="ghost" disabled className="w-full border border-white/10">Current Plan</Button>
            </div>

            {/* Pro Tier */}
            <div className="relative">
                <div className="absolute -inset-4 bg-primary/5 rounded-xl -z-10"></div>
                <h3 className="text-lg font-bold text-primary mb-4 flex items-center gap-2">
                    Pro Writer <Star className="w-4 h-4 fill-primary text-primary" />
                </h3>
                <ul className="space-y-3 mb-6">
                    <li className="flex items-center gap-2 text-sm text-white"><Check className="w-4 h-4 text-primary"/> <strong>Unlimited</strong> Words</li>
                    <li className="flex items-center gap-2 text-sm text-white"><Zap className="w-4 h-4 text-secondary"/> Gemini 3 Pro Engine</li>
                    <li className="flex items-center gap-2 text-sm text-white"><Shield className="w-4 h-4 text-green-400"/> Voice Anchoring</li>
                    <li className="flex items-center gap-2 text-sm text-white"><Check className="w-4 h-4 text-primary"/> Priority Processing</li>
                </ul>
                <div className="text-2xl font-bold text-white mb-4">$9.99<span className="text-sm font-normal text-subtext">/mo</span></div>
                <Button onClick={() => handleCheckout('monthly')} className="w-full font-bold shadow-glow-primary">
                    Upgrade Now
                </Button>
            </div>
        </div>
        
        <div className="bg-primary/5 p-4 text-center text-xs text-primary/80 border-t border-primary/10">
            <span className="font-bold">100% Money-Back Guarantee.</span> Cancel anytime.
        </div>

      </div>
    </div>
  );
};